module.exports = __webpack_public_path__ + "static/img/core-trad-pc-bg.019ebd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/core-trad-pc-bg.png
// module id = v8LC
// module chunks = 0